import { CalculatorIcon, DocumentTextIcon } from '@heroicons/vue/solid'
import { i18n } from '../../../../localization'
import { ComputedRef, ConcreteComponent, RenderFunction, computed } from 'vue'
import { App } from '../../../../typings/api-enums'
import { EcspComplianceProfile } from '../../../../utilities/account/useAccountDataPersonal'
import InvestorClassificationForm from '../../../wizard/ECSP/legal/InvestorClassificationForm.vue'
import RiskForm from '../../../wizard/ECSP/legal/RiskForm.vue'
import FinancialSituationForm from '../../../wizard/ECSP/legal/FinancialSituationForm.vue'

import {
    showNotEnoughInvestorClassificationWarning,
    showNotEnoughRiskAcknowledgementsWarning,
} from '../../../../utilities/account/useEcspRegulatory'

export const ecspLegalComplianceProfileConfig: EcspLegalComplianceProfileConfig = {
    'Investor Classification': {
        component: InvestorClassificationForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('legal_account.investor_classification'),
        validationKey: 'investor_classification',
        denyKey: `investor_classification.expert_investor_treatment,${App.Enums.ComplianceProfile.YesNoOption.NO}`,
        showsWarning: computed(() => showNotEnoughInvestorClassificationWarning()),
        clearValuesOnClose: true,
    },
    'Risk': {
        component: RiskForm,
        icon: DocumentTextIcon,
        title: i18n.global.t('legal_account.risk'),
        validationKey: 'risk',
        denyKey: 'risk.no_answer',
        showsWarning: computed(() => showNotEnoughRiskAcknowledgementsWarning()),
        clearValuesOnClose: true,
    },
    'Financial Situation': {
        component: FinancialSituationForm,
        icon: CalculatorIcon,
        title: i18n.global.t('legal_account.financial_situation'),
        buttonTitle: i18n.global.t('ecsp.financial_situation.calculate'),
        validationKey: 'financial_situation',
        hideStatus: true,
        clearValuesOnClose: true,
        requireConfirm: true,
    },
}

export interface EcspLegalComplianceProfileConfig {
    [key: string]: {
        component: ConcreteComponent
        icon: RenderFunction | ConcreteComponent
        title: string
        buttonTitle?: string
        validationKey: keyof EcspComplianceProfile
        denyKey?: string
        showsWarning?: ComputedRef<boolean>
        hideStatus?: boolean
        clearValuesOnClose?: boolean
        requireConfirm?: boolean
    }
}
